import {
  MS_ADDON_SKUS,
  MS_CONFIG_SKUS,
} from './ms-constants'
import type { Product } from '@/js/services/RogueTypes'
import type { BuyRequest } from '@/js/services/types/order'
import type { ProductMeasurementConfig } from '../../RackTypes'

// Corner detection for zoom level: reads the CONFIG leaf's mass_width attribute.
// mass_width = 'corner' identifies a corner addon vs a numeric width like '43"' or '70"'.
function getMsAddonIsCorner(addon: BuyRequest, products: Record<string, Product>): boolean {
  const configBR = addon.children?.find(c => MS_CONFIG_SKUS.includes(products[String(c.productId)]?.sku ?? ''))
  if (!configBR) return false

  let br: BuyRequest = configBR
  while (br.children?.length) br = br.children[0]

  const massWidth = products[String(br.productId)]?.attributes?.mass_width?.toString().replace('"', '')

  return massWidth?.toLowerCase() === 'corner'
}

export function getMsZoomLevel(buyRequest: BuyRequest, products: Record<string, Product>): number {
  const addons = buyRequest.children
    ?.filter(c => MS_ADDON_SKUS.includes(products[String(c.productId)]?.sku ?? '') && c.qty > 0)

  const addonCount = addons?.length ?? 0
  const hasCorner  = addons?.some(br => getMsAddonIsCorner(br, products)) ?? false

  if (addonCount === 0) return 3
  if (addonCount > 6 || (addonCount > 1 && hasCorner)) return 1.5
  if (addonCount >= 1) return 2

  return 1.5
}

export const MS_MEASUREMENT_CONFIG: ProductMeasurementConfig = {
  dynamic               : true,
  measurementDistance   : 1,
  maxMeasurementHeight  : 0.4,
  edgeDistanceThreshold : 1,
  defaultZoomLevel      : 1.5,
  getZoomLevel          : getMsZoomLevel,
  geometryMeshPatterns  : ['_upright', '(mat|main)_corner'], // reference geometry and replaces mesh-value lookup with physical geometry span measurement.
  cornerFilterAngles    : [{ min: -5, max: 5 }], // MS L-shape corners sit at different angles than MMS so an override is needed
  inchesPerUnit         : 39.3701, // rackbuilder repo defaults to a 38 scale factor (based on MMS needs)
}
